<template>
  <div class="price_sidebar rounded-lg box-shadow-sm" id="shop-sidebar" style="margin-bottom: -10px;background: white">
    <div class="box-shadow-sm">

    </div>
    <div class="pb-0" style="padding-top: 12px;">
      <div class=" sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isProfile ? 'active-menu' : ''" href="/account/profile">
            {{ t("users.title") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
    <div class="pb-0">
      <div class=" sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isAddresses ? 'active-menu' : ''" href="/account/addresses">
            {{ t("accounts.address") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
    <div class="pb-0">
      <div class=" sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isRefundAccounts ? 'active-menu' : ''" href="/account/refund-accounts">
            {{ t("orders.refundAccount") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
    <div class="pb-0">
      <div class="sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isOrders ? 'active-menu' : ''" href="/account/orders">
            {{ t("orders.title") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
    <div v-if="website_type == 'wholesale'" class="pb-0">
      <div class="sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isCoins ? 'active-menu' : ''" href="/account/coins">
            {{ t("coins.record") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
    <div v-if="website_type == 'wholesale'" class="pb-0">
      <div class="sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isSubscription ? 'active-menu' : ''" href="/account/subscriptions">
            {{ t("subscriptions.record") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
    <div class="pb-0">
      <div class="sidebarL">
        <h3 class="widget-title btnF" style="font-weight: 700;">
          <a :class="isPromotionCode ? 'active-menu' : ''" href="/account/promotion-codes">
            {{ t("promotions.code") }}
          </a>
        </h3>
        <div class="divider-role" style="border: 1px solid whitesmoke; margin-bottom: 14px;  margin-top: -6px;">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from "vue-i18n"

const { t, locale } = useI18n()

const isProfile = computed(() => location.pathname.indexOf('account/profile') > -1)
const isAddresses = computed(() => location.pathname.indexOf('account/addresses') > -1)
const isRefundAccounts = computed(() => location.pathname.indexOf('account/refund-accounts') > -1)
const isOrders = computed(() => location.pathname.indexOf('account/orders') > -1)
const isPeriodOrders = computed(() => location.pathname.indexOf('account/period-orders') > -1)
const isCoins = computed(() => location.pathname.indexOf('account/coins') > -1)
const isSubscription = computed(() => location.pathname.indexOf('account/subscriptions') > -1)
const isPromotionCode = computed(() => location.pathname.indexOf('account/promotion-codes') > -1)

const props = defineProps({
  website_type: String
})

</script>

<style>
    body {
        font-family: sans-serif;
    }

    .footer span {
        font-size: 12px
    }

    .product-qty span {
        font-size: 12px;
        color: #6A6A6A;
    }

    label {
        font-size: 16px;
    }

    .divider-role {
        border-bottom: 1px solid whitesmoke;
    }

    .sidebarL h3:hover + .divider-role {
        border-bottom: 3px solid var(--secondary_color) !important;
        transition: .2s ease-in-out;
    }

    .price_sidebar {
        padding: 20px;
    }

    @media (max-width: 600px) {

        .sidebar_heading h1 {
            text-align: center;
            color: aliceblue;
            padding-bottom: 17px;
            font-size: 19px;
        }

        .sidebarR {
            padding: 24px;
        }

        .price_sidebar {
            padding: 20px;
        }
    }
</style>